import React from 'react'
import Banner from './Banner'
import Deal from './Deal'
import Topproduct from './Topproduct'
import FeaturedBann from './FeaturedBann'
import Featuredproduct from './Featuredproduct'

const Home = () => {
  return (
    <>
      <Banner/>
      <Deal/>
      <Topproduct/>
      <FeaturedBann/>
      <Featuredproduct/>
    </>
  )
}

export default Home
